import type { ReactNode } from 'react'

import './browse.css'

export type StatTone = 'neutral' | 'income' | 'refund' | 'total'

/** Строка таблицы внутри карточки: подпись слева, величина справа. */
export interface StatRow {
  label: string
  value: string
}

export interface StatItem {
  id: string
  label: string
  /** Крупная величина: «12 450,00 ₽». */
  value: string
  /** Строки таблицы под суммой в порядке показа: «Наличными», «Картой», «Чеков». Фраз и пояснений в карточке нет. */
  rows?: readonly StatRow[]
  /** Смысл карточки: показывается цветом полосы слева и словом подписи. */
  tone?: StatTone
  icon?: ReactNode
}

/**
 * Сводка крупными цифрами над списком: приход, возвраты, итог, число чеков. Список определений (`dl`), чтобы диктор
 * читал пары «подпись — величина». У каждой карточки заголовок с крупной суммой и таблица строк: подпись слева, величина
 * справа, одним цветом. Пока данные читаются — `busy`, цифры не подменяются нулями.
 */
export function StatCards({ label, items, busy = false }: { label: string; items: readonly StatItem[]; busy?: boolean }) {
  return (
    <dl className="krp-stats" aria-label={label} aria-busy={busy || undefined}>
      {items.map((item) => (
        <div key={item.id} className="krp-stat" data-tone={item.tone ?? 'neutral'}>
          <dt className="krp-stat__label">
            {item.icon}
            {item.label}
          </dt>
          <dd className="krp-stat__value">{item.value}</dd>
          {item.rows?.flatMap((row) => [
            <dt key={`${row.label}-label`} className="krp-stat__row-label">{row.label}</dt>,
            <dd key={`${row.label}-value`} className="krp-stat__row-value">{row.value}</dd>,
          ])}
        </div>
      ))}
    </dl>
  )
}
